export const SITE = {
    name: "Busy Bees Early Learning Academy Pvt Ltd",
    shortName: "Busy Bees",
    tagline: "Where little learners buzz with joy",
    phone: "+94 70 210 7622",
    phoneHref: "tel:+94702107622",
    whatsappHref:
        "https://wa.me/94702107622?text=Hello%20Busy%20Bees%2C%20I%20would%20like%20to%20book%20a%20tour.",
    email: "admin@busybeeslk.com",
    address: "26 Galwatte Road, Pelmadulla, Rathnapura",
    hoursLine: "Mon–Fri · 7:30 AM – 5:00 PM",
    ages: "Ages 6 weeks – 5 years",
};

const img = (id, w = 1200) =>
    `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
    hero: "/busy-bees-outdoor-learning.jpg",
    infants: img("1578349035260-9f3d4042f1f7"),
    toddlers: img("1600880291319-1a7499c191e8"),
    preschool: img("1761604478724-13fe879468cf"),
    prek: img("1777056481869-feac70afe522"),
    collageMain: img("1786292949404-084cbd10c7b1", 1400),
    collageSmall: img("1777056491418-d4ff81a4ad92", 800),
    galleryIndoor: [
        img("1761208663763-c4d30657c910"),
        img("1777056491418-d4ff81a4ad92"),
        img("1777056481869-feac70afe522"),
    ],
    galleryOutdoor: [
        img("1630637991997-1cd9c8b41ce1"),
        img("1630139026575-d11e637ce0fc"),
        img("1630139026564-4a2bf5670879"),
    ],
    galleryArt: [
        img("1666710988451-ba4450498967"),
        img("1620398722262-969d8f2bc875"),
        img("1560421683-6856ea585c78"),
    ],
    galleryMoments: [
        "/busy-bees-moment-picnic.webp",
        "/busy-bees-moment-cake-one.webp",
        "/busy-bees-moment-cake-two.webp",
    ],
};

export const PROGRAMS = [
    {
        id: "infants",
        name: "The Honeycomb Nest",
        group: "Infants",
        age: "6 – 18 months",
        ratio: "1:4",
        description:
            "Gentle routines, sensory wonder and plenty of cozy one-on-one care. Our calmest room hums with soft songs, tummy time and first discoveries.",
        highlights: [
            "Sensory & tummy-time play",
            "Baby sign language, songs & rhymes",
            "Daily photo & nap updates for parents",
        ],
        image: IMAGES.infants,
    },
    {
        id: "toddlers",
        name: "The Buzzing Bumbles",
        group: "Toddlers",
        age: "18 months – 3 years",
        ratio: "1:6",
        description:
            "Wobbly steps become confident leaps. Toddlers build language, balance and independence through movement, music and mess-friendly discovery.",
        highlights: [
            "Music, movement & lots of outdoor play",
            "Early language bloom & first friendships",
            "Gentle, pressure-free toilet learning",
        ],
        image: IMAGES.toddlers,
    },
    {
        id: "preschool",
        name: "The Pollinators",
        group: "Preschool",
        age: "3 – 4 years",
        ratio: "1:8",
        description:
            "Curiosity leads the way. Hands-on projects, story adventures and make-believe turn every day into a brand-new expedition.",
        highlights: [
            "Play-based early literacy & numeracy",
            "Art, building & sensory studios",
            "Friendship & feelings skills",
        ],
        image: IMAGES.preschool,
    },
    {
        id: "prek",
        name: "The Queen Bees",
        group: "Pre-K",
        age: "4 – 5 years",
        ratio: "1:10",
        description:
            "A joyful launchpad for kindergarten. Big questions, garden science and growing confidence get our oldest bees ready to fly.",
        highlights: [
            "Kindergarten readiness curriculum",
            "STEM garden & science explorations",
            "Confidence, independence & leadership",
        ],
        image: IMAGES.prek,
    },
];

export const DAY_TIMELINE = [
    { time: "7:00 AM", label: "Welcome & free choice", note: "Sunshine greetings and gentle arrivals" },
    { time: "8:30 AM", label: "Morning circle", note: "Songs, stories and today's big question" },
    { time: "9:15 AM", label: "Learning studios", note: "Play-based projects, blocks, books & letters" },
    { time: "10:15 AM", label: "Honeycomb snack", note: "Fresh fruit, whole grains and water" },
    { time: "10:45 AM", label: "Outdoor adventure", note: "Garden beds, gross-motor play and fresh air" },
    { time: "12:00 PM", label: "Lunch & tidy-up", note: "Family-style tables and little responsibilities" },
    { time: "12:45 PM", label: "Storytime & rest", note: "Cozy cots, dim lights and quiet breathing" },
    { time: "2:45 PM", label: "Wake-up snack", note: "Sleepy smiles refuel for the afternoon" },
    { time: "3:30 PM", label: "Art & discovery", note: "Painting, sensory bins and music-making" },
    { time: "5:00 PM", label: "Pickup & farewell", note: "Hugs, high-fives and tomorrow's excitement" },
];

export const TEAM = [
    {
        id: "roshani-pushpamala",
        name: "Roshani Pushpamala",
        role: "Directress & Founder",
    },
    {
        id: "chatura-wanninayake",
        name: "Chatura Wanninayake",
        role: "Director Operations",
    },
    {
        id: "randika-jayasekara",
        name: "Randika Jayasekara",
        role: "Educator",
    },
    {
        id: "kawya-bodirathne",
        name: "Kawya Bodirathne",
        role: "Educator",
    },
    {
        id: "achini-atapattu",
        name: "Achini Atapattu",
        role: "Educator & Daycare Teacher",
    },
    {
        id: "lakshani-sumya",
        name: "Lakshani Sumya",
        role: "Educator",
    },
    {
        id: "tharanga-thathsarani",
        name: "Tharanga Thathsarani",
        role: "Educator",
    },
    {
        id: "nimni",
        name: "Nimni",
        role: "Educator",
    },
    {
        id: "devindi-warunashantha",
        name: "Devindi Warunashantha",
        role: "Educator",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "Our daughter runs to the door every single morning. She has grown so confident, curious and kind in her time here.",
        name: "Rachel M.",
        detail: "Mom of a preschooler",
    },
    {
        quote:
            "The teachers know every child by name — and every little quirk. We drop him off feeling completely at ease.",
        name: "James & Olivia T.",
        detail: "Parents of a toddler",
    },
    {
        quote:
            "Busy Bees gave our son the softest landing and the bravest start. Choosing this place was the best decision we made.",
        name: "Nina K.",
        detail: "Mom of a Pre-K graduate",
    },
];
